module.exports = __webpack_public_path__ + "static/img/Ben_Cunnington_mobile.759d547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben_Cunnington_mobile.jpg
// module id = oRVC
// module chunks = 0